import { hasEmissionsTable } from 'Utils';

export const constructCSVFixedTable = (dataSetResponse, dataTemplate, defaultValue, additionalMsgStrings = []) => {
  if (!dataSetResponse || !dataTemplate) {
    return [];
  }

  const formatDatafield = (s) => {
    if (!s) {
      return s;
    }
    return s.replace(/\s*\|\s*/g, '|').replace(/\s*-\s*/g, '-');
  };

  const filteredTableData = dataSetResponse.map((data) => {
    const tableDataKeys = Object.keys(data.datafields);
    const newData = {};
    tableDataKeys.map((key) => (newData[formatDatafield(key)] = data.datafields?.[key]));
    return { ...data, datafields: newData };
  });

  function removeDashsFromData(inputDataSet) {
    function replaceDashes(inputString) {
      // Use a regular expression to match en dash, em dash, and non-breaking hyphen
      return inputString.replace(/–|—|‑/g, '-');
    }
    // Process rows
    inputDataSet.rows.forEach((row) => {
      row.display = replaceDashes(row.display);
    });

    // Process columns
    inputDataSet.columns.forEach((column) => {
      column.display = replaceDashes(column.display);
    });

    return inputDataSet;
  }

  dataTemplate = removeDashsFromData(dataTemplate);

  let entityHeadingList = [];
  let estimateActualHeadingList = [''];
  let reportingYearList = [''];

  const entityColSpanInfo = { '': 1 };
  dataSetResponse.forEach((entityData) => {
    let totalColumns = 0;
    dataTemplate?.columns?.forEach((colGroup) => {
      if (colGroup?.subColumns && colGroup?.subColumns?.length > 0) {
        totalColumns += colGroup?.subColumns?.length || 0;
      } else {
        totalColumns += 1;
      }
    });
    const entityOrPortfolioName = entityData.consolidatedInPortfolio ? entityData.portfolio : entityData.entity;
    if (entityColSpanInfo[entityOrPortfolioName]) {
      entityColSpanInfo[entityOrPortfolioName] += 1 * (totalColumns || 1);
    } else {
      entityColSpanInfo[entityOrPortfolioName] = 1 * (totalColumns || 1);
    }
  });
  Object.keys(entityColSpanInfo).map((entity) => {
    const entityArray = Array(entityColSpanInfo[entity] || 1).fill('');
    entityArray[0] = entity;
    entityHeadingList = entityHeadingList.concat(entityArray);
  });

  // estimate/actual heading
  if (hasEmissionsTable(dataSetResponse)) {
    dataSetResponse.forEach((entityData) => {
      let totalEstimateActualColumns = 0;
      dataTemplate?.columns?.forEach((colGroup) => {
        if (colGroup?.subColumns && colGroup?.subColumns?.length > 0) {
          totalEstimateActualColumns += colGroup?.subColumns?.length || 0;
        } else {
          totalEstimateActualColumns += 1;
        }
      });
      const individualEstimateActualArray = Array(totalEstimateActualColumns || 1).fill('');
      individualEstimateActualArray[0] = entityData.hasActualData ? 'Amended' : 'Annual Report';
      estimateActualHeadingList = estimateActualHeadingList.concat(individualEstimateActualArray);
    });
  }

  // reporting year
  dataSetResponse.forEach((entityData) => {
    let totalReportingYearColumns = 0;
    dataTemplate?.columns?.forEach((colGroup) => {
      if (colGroup?.subColumns && colGroup?.subColumns?.length > 0) {
        totalReportingYearColumns += colGroup?.subColumns?.length || 0;
      } else {
        totalReportingYearColumns += 1;
      }
    });
    const individualReportingYearArray = Array(totalReportingYearColumns || 1).fill('');
    individualReportingYearArray[0] = entityData.reportingPeriod;
    reportingYearList = reportingYearList.concat(individualReportingYearArray);
  });

  // column group/column
  let columnList = [''];
  dataSetResponse?.forEach(() => {
    dataTemplate?.columns?.forEach((col) => {
      const colArray = Array(col?.subColumns?.length || 1).fill('');
      colArray[0] = col.display;
      columnList = columnList.concat(colArray);
    });
  });

  const subColList = [''];
  dataSetResponse?.forEach(() => {
    dataTemplate.columns?.forEach((col) => {
      col?.subColumns?.map((subCol) => {
        subColList.push(subCol.display);
      });
    });
  });

  const tableDataValues = [];
  dataTemplate?.rows?.forEach((row) => {
    let rowData = [row.display];
    filteredTableData?.forEach((entityYearData) => {
      let colData = [];
      dataTemplate.columns?.forEach((col) => {
        if (col.subColumns?.length > 0) {
          colData = colData.concat(
            col.subColumns?.map((subCol) => {
              // If is row heading, don't render any values here
              return row.isRowHeading
                ? ''
                : entityYearData.datafields?.[
                    subCol.key?.toLowerCase().trim()
                      ? `${row.key?.toLowerCase().trim()}${row.key ? '|' : ''}${col.key?.toLowerCase().trim()}-${subCol.key?.toLowerCase().trim()}`
                      : `${row.key?.toLowerCase().trim()}|${col.key?.toLowerCase().trim()}`
                  ] || defaultValue;
            }) || [],
          );
        } else {
          colData.push(
            row.isRowHeading ? '' : entityYearData.datafields?.[`${row.key?.toLowerCase().trim()}${row.key ? '|' : ''}${col.key?.toLowerCase().trim()}`] || defaultValue,
          );
        }
      });
      rowData = rowData.concat(colData);
    });
    tableDataValues.push(rowData);
  });
  tableDataValues.push(['']); // empty row between data and disclosure text
  additionalMsgStrings.forEach((msg) => {
    tableDataValues.push([msg]);
  });

  const hasSubColumns = dataTemplate?.columns?.some((col) => col?.subColumns?.length > 0);

  return [entityHeadingList, estimateActualHeadingList.length > 1 ? estimateActualHeadingList : null, reportingYearList, columnList, hasSubColumns ? subColList : null]
    .filter(Boolean)
    .concat(tableDataValues);
};

export const constructCSVAppendTable = (dataSetResponse, dataTemplate, defaultValue) => {
  if (!dataSetResponse || !dataTemplate) {
    return [];
  }

  let columnList = [];
  dataTemplate?.columns?.forEach((col) => {
    const colArray = Array(col?.subColumns?.length || 1).fill('');
    colArray[0] = col.display;
    columnList = columnList.concat(colArray);
  });

  let subColList = [];
  dataTemplate.columns?.forEach((col) => {
    col?.subColumns?.map((subCol) => {
      subColList.push(subCol.display);
    });
  });

  const tableDataValues = [];
  let rowData = [];
  dataSetResponse?.forEach((entityYearData) => {
    entityYearData.datafields?.forEach((dfRow) => {
      let colData = [];
      dataTemplate.columns?.forEach((col) => {
        if (col.subColumns?.length > 0) {
          colData = colData.concat(
            col.subColumns?.map((subCol) => {
              if (subCol.concatFields?.length) {
                let valuesToConcat = [];
                subCol.concatFields.map((concatField) => {
                  valuesToConcat.push(dfRow?.[`${concatField?.toLowerCase()}`]);
                });

                return dfRow['name'] || valuesToConcat.length > 0 ? valuesToConcat.join(' ') : defaultValue;
              } else {
                return dfRow?.[`${subCol.key?.toLowerCase()}`] || defaultValue;
              }
            }) || [],
          );
        } else {
          if (col.concatFields?.length) {
            let valuesToConcat = [];
            if (dfRow['name']) {
              colData.push(dfRow['name'] || defaultValue);
            } else {
              col.concatFields.map((concatField) => {
                valuesToConcat.push(dfRow?.[`${concatField?.toLowerCase()}`] || defaultValue);
              });
              colData.push(valuesToConcat.join(' '));
            }
          } else {
            colData.push(dfRow?.[`${col.key?.toLowerCase()}`] || defaultValue);
          }
        }
      });
      rowData = rowData.concat(colData);
      tableDataValues.push(colData);
    });
  });

  const hasSubColumns = dataTemplate?.columns?.some((col) => col?.subColumns?.length > 0);

  return [columnList, hasSubColumns ? subColList : null].filter(Boolean).concat(tableDataValues);
};
